export default Object.freeze({
  ERROR: '/error',
  CONTACT_US: '/contact-us',
  HELP: '/help',
});
